import * as React from "react";
import { connect } from "react-redux";

import * as actions from "../../actions";
import {
  TextArea as TextAreaComponent,
  TextAreaProps as TextAreaComponentProps,
} from "../../components/TextArea/TextArea";
import { StoreState } from "../../reducers";
import { getWidgetFormErrors } from "../../reducers/methods";

interface TextAreaProps extends TextAreaComponentProps {
  clearWidgetFormError: typeof actions.clearWidgetFormError;
  formErrors: {
    [key: string]: { [index: string]: any };
  };
  setWidgetFormError: typeof actions.setWidgetFormError;
  setUserInput: typeof actions.setUserInput;
}

class TextArea extends React.Component<TextAreaProps> {
  render() {
    const { setWidgetFormError, setUserInput } = this.props;

    return (
      <TextAreaComponent
        {...this.props}
        onFormError={setWidgetFormError}
        onFormChange={setUserInput}
      />
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  formErrors: getWidgetFormErrors(state),
});

export default connect(mapStateToProps, {
  clearWidgetFormError: actions.clearWidgetFormError,
  setWidgetFormError: actions.setWidgetFormError,
  setUserInput: actions.setUserInput,
})(TextArea);
